<template>
    <div class="content-i">
        <div class="content-box">

            <!--START - Recent Ticket Comments-->
            <div class="element-wrapper">
                <div class="element-actions d-none d-sm-block">
                    <a class="btn btn-primary btn-sm">
                        <i class="os-icon os-icon-ui-22"></i>
                        <span @click="formMode = 'add'">
                            Add Model
                        </span>
                    </a>
                </div>
                <h6 class="element-header">Models</h6>
                <div class="element-box-tp" v-if="formMode == 'view'">
                    <EmptyState v-if="!pagination.data">
                        <div slot="empty_state_text">
                            There are no models
                        </div>
                    </EmptyState>
                    <Loader v-if="isLoading == false" />
                    <div class="table-responsive" v-else>
                        <table class="table table-padded">
                            <thead>
                                <tr>
                                    <th>Model Name</th>
                                    <th>Agency</th>
                                    <th>Gender</th>
                                    <th>Stats</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="model in pagination.data">
                                    <td>
                                        <div class="user-with-avatar"><img alt="" :src="model.avatar">
                                            <span>{{model.name}}</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div>{{model.agency_name}}</div>
                                    </td>
                                    <td>
                                        <div>{{model.gender}}</div>
                                    </td>
                                    <td>
                                        <div>{{model.model_stats}}</div>
                                    </td>
                                    <td class="nowrap">
                                        <div v-html="formatModelStatus(model)"></div>
                                    </td>
                                    <td class="row-actions">
                                        <a @click="editModel(model)">
                                            <i class="fas fa-pencil"></i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <Pagination v-if="pagination.last_page > 1 " :pagination="pagination" @paginate="getExportedReports()" :offset="5"></Pagination>
                </div>
                <div class="element-box p-10" v-if="formMode == 'add'">
                    <form id="addModelForm">
                        <h5 class="form-header">Add Model</h5>
                        <div class="form-desc">You can add a new model using this form</div>

                        <div class="form-group row">
                            <label class="col-form-label col-sm-4" for=""> Avatar</label>
                            <div class="col-sm-8">
                                <input type="file" id="avatar" name="avatar">
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-form-label col-sm-4" for=""> Model Name</label>
                            <div class="col-sm-8"><input name="name" class="form-control" placeholder="Enter model name" type="text"></div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label" for=""> Agency Name</label>
                            <div class="col-sm-8"><input class="form-control" name="agency_name" placeholder="Agency Name" type="text"></div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Gender</label>
                            <div class="col-sm-8">
                                <div class="form-check">
                                    <label class="form-check-label"><input checked="" class="form-check-input" name="gender" type="radio" value="male">Male</label>
                                </div>
                                <div class="form-check">
                                    <label class="form-check-label"><input class="form-check-input" name="gender" type="radio" value="female">Female</label>
                                </div>

                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Model Stats</label>
                            <div class="col-sm-8">
                                <textarea class="form-control" name="model_stats" rows="3"></textarea>
                            </div>
                        </div>
                        <div class="form-buttons-w">
                            <button class="btn btn-primary" type="button" @click="addModel()"> Submit</button>
                            <button class="btn btn-primary" type="button" @click="formMode = 'view'"> Cancel</button>

                        </div>
                    </form>
                </div>
                <div class="element-box p-10" v-if="formMode == 'edit'">
                    <form id="editModelForm">
                        <h5 class="form-header">Edit Model</h5>
                        <div class="form-desc">You can edit model using this form</div>

                        <div class="form-group row">
                            <label class="col-form-label col-sm-4" for=""> Avatar</label>
                            <div class="col-sm-8">
                                <img alt="" class="user-avatar-w" :src="selectedModel.avatar">
                                <input type="file" id="avatar" name="avatar" @change="updateAvatar">
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-form-label col-sm-4" for=""> Model Name</label>
                            <div class="col-sm-8"><input v-model="selectedModel.name" name="name" class="form-control" placeholder="Enter model name" type="text"></div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label" for=""> Agency Name</label>
                            <div class="col-sm-8"><input v-model="selectedModel.agency_name" class="form-control" name="agency_name" placeholder="Agency Name" type="text"></div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Gender</label>
                            <div class="col-sm-8">
                                <div class="form-check">
                                    <label class="form-check-label"><input v-model="selectedModel.gender" :checked="selectedModel.gender == 'male'" class="form-check-input" name="gender" type="radio" value="male">Male</label>
                                </div>
                                <div class="form-check">
                                    <label class="form-check-label"><input v-model="selectedModel.gender" :checked="selectedModel.gender == 'female'" class="form-check-input" name="gender" type="radio" value="female">Female</label>
                                </div>

                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Model Stats</label>
                            <div class="col-sm-8">
                                <textarea v-model="selectedModel.model_stats" class="form-control" name="model_stats" rows="3"></textarea>
                            </div>
                        </div>
                        <div class="form-buttons-w">
                            <button class="btn btn-primary" type="button" @click="updateModel()"> Update</button>
                            <button class="btn btn-primary" type="button" @click="formMode = 'view'"> Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import EmptyState from '@/components/common/EmptyState'
import Loader from '@/components/common/Loader'

export default {
  components: {
    Pagination,
    EmptyState,
    Loader
  },
  data: function () {
    return {
      isLoading: true,
      formMode: 'view',
      selectedModel: {
        agency_name: '',
        avatar: '',
        updatedavatar: '',
        gender: '',
        id_user: '',
        is_active: '',
        model_stats: '',
        name: ''
      },
      pagination: {
        current_page: 1
      }
    }
  },
  mounted: function () {
    var self = this
    this.getModels()
  },
  methods: {
    getModels: function () {
      var self = this
      const url = '/orgdesk/models'
      self.isLoading = true
      this.$http
        .get(url, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          console.log(response)
          self.pagination = response.data.models
          self.isLoading = true
        })
        .catch(function (error) {
          console.log(error)
          self.isLoading = true
        })
    },
    editModel (model) {
      this.selectedModel = model
      this.formMode = 'edit'
    },
    addModel: function () {
      var self = this

      const url = '/orgdesk/model/add'

      var form = document.getElementById('addModelForm')
      let data = new FormData(form)

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          console.log(response)
          self.$store.dispatch('updateToast', {
            text: 'Model created',
            show: true
          })
          self.getModels()
          self.formMode = 'view'
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text:
              (error.response && error.response.data.error) ||
              'Something went wrong',
            show: true
          })
        })
    },
    updateAvatar (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      this.createImage(files[0])
    },
    createImage (file) {
      var image = new Image()
      var reader = new FileReader()
      var self = this

      reader.onload = (e) => {
        self.selectedModel.avatar = e.target.result
        self.selectedModel.updatedavatar = e.target.result
      }
      reader.readAsDataURL(file)
    },
    updateModel: function () {
      var self = this

      const url = '/orgdesk/model/update'

      var form = document.getElementById('editModelForm')
      let data = JSON.parse(JSON.stringify(this.selectedModel))

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          console.log(response)
          self.$store.dispatch('updateToast', {
            text: 'Model updated',
            show: true
          })
          self.getModels()
          self.formMode = 'view'
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text:
              (error.response && error.response.data.error) ||
              'Something went wrong',
            show: true
          })
        })
    },
    formatModelStatus: function (model) {
      var response = ''
      if (model.is_active == 0) {
        ('<span class="status-pill smaller red"></span><span>Inactive</span>')
      } else {
        response =
          '<span class="status-pill smaller green"></span><span>Active</span>'
      }

      return response
    }
  }
}
</script>

<style scoped>
.user-avatar-w {
    border-radius: 50px;
    width: 100px;
    height: auto;
}
</style>
